import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const CandidateLocationChart = ({ data, description }) => {
  // Colors for chart
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FFC658', '#8DD1E1'];

  // Data preparation for chart
  const candidateLocationData = () => {
    const locationCounts = {};
    
    data.forEach(candidate => {
      // Skip candidates with empty or undefined location
      if (!candidate.location || candidate.location.trim() === '') return;
      
      if (!locationCounts[candidate.location]) {
        locationCounts[candidate.location] = 0;
      }
      locationCounts[candidate.location]++;
    });
    
    return Object.entries(locationCounts)
      .map(([location, count]) => ({
        name: location,
        value: count
      }))
      .sort((a, b) => b.value - a.value);
  };

  return (
    <div className="dashboard-card p-6 slide-in-up" style={{animationDelay: '1000ms'}}>
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-800">Candidate Locations</h3>
        <div className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-1 rounded-full">
          Geography
        </div>
      </div>
      {description && (
        <p className="text-sm text-gray-600 mb-4">{description}</p>
      )}
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={candidateLocationData()}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
            nameKey="name"
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          >
            {candidateLocationData().map((entry, index) => (
              <Cell 
                key={`cell-${index}`} 
                fill={COLORS[index % COLORS.length]} 
                stroke="rgba(255,255,255,0.5)"
                strokeWidth={1}
              />
            ))}
          </Pie>
          <Tooltip 
            contentStyle={{ 
              borderRadius: '8px', 
              border: 'none', 
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              fontSize: '12px'
            }}
            formatter={(value) => [`${value} candidates`, 'Count']}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CandidateLocationChart;
